import StartEarningTodayImg from "images/start-earning.png";
import Badge from "shared/Badge/Badge";

const StartEarningToday = () => {
  const benefits = [
    { title: "Free up cash", description: "Put your car to work and generate income you can use for anything you desire." },
    { title: "No hassle rentals", description: "We handle everything - you don't have to deal with renters directly." },
    { title: "Peace of mind", description: "Your car is protected with comprehensive insurance while it's rented." },
  ];
  return (
    <div className="text-[#3B3B3B] py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center">
        <div className="relative lg:w-3/4">
          <img
            src={StartEarningTodayImg}
            alt="Start Earning Today"
            className="rounded-xl object-cover"
          />
        </div>
        <div className="space-y-8">
          <h2 className="text-4xl font-bold">
            Start Earning Today!
           
          </h2>

          <ul className="space-y-6">
            {benefits.map((benefit, index) => (
              <li key={index} className="flex items-start space-x-4">
                <svg
                  className="flex-shrink-0 mt-1"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#E6F7FF" />
                  <path
                    d="M16.5 8.5L10.5 14.5L7.5 11.5"
                    stroke="#1E90FF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <div>
                  <h3 className="text-lg font-semibold text-gray-700">{benefit.title}</h3>
                  <p className="text-gray-500">{benefit.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StartEarningToday;